export default __webpack_public_path__ + "static/banner_1-a3d41210024b71638caf1402b6cb5ec9.webp";